module.exports = __webpack_public_path__ + "img/Savelend.bbea23d3.png";